import { MergedBase } from "../mfrm-choose-your-foundation";
import { Tab } from "../mfrm-choose-your-foundation";

export const getKeys = (bases: MergedBase[], selectedTab: Tab) : (string|number)[] => {
    const keys = [
        'Mattress Only',
        ...bases
            ?.filter(base => {
                return (
                    selectedTab === 'All' ||
                    (selectedTab === 'Adjustable Bases' && base.productType === 'Adjustable Bases') ||
                    (selectedTab === 'Box Springs' && base.productType === 'Box Springs')
                );
            })
            .map(base => base.RecordId)
    ];
    return keys;
};
